import script from "./ModulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulePage.vue?vue&type=script&setup=true&lang=js"

import "./ModulePage.vue?vue&type=style&index=0&id=af9e6072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9e6072"]])

export default __exports__